import fetch from '@/plugins/fetch'
import queryString from 'query-string'
import { PREFIX_SCC_API } from '@/service'
const api = {
  cms: '//cms.cekid.com/publish/999/newShare.json',
  querySpuChecklists: PREFIX_SCC_API + '/fchild/worker/querySpuChecklists.do', // 分享赚我的清单列表接口
  addSpuChecklist: PREFIX_SCC_API + '/fchild/worker/addSpuChecklist.do', // 分享赚添加spu到清单
  deleteChecklistBySpuId:
    PREFIX_SCC_API + '/fchild/worker/deleteChecklistBySpuId.do' // 删除清单列表的商品
}

export default {
  async getActivityShareConfig() {
    const res = await fetch(`${api.cms}`)
    const json = await res.json()
    return json.data
  },
  // 分享赚我的清单列表接口
  async getSpuChecklists({ commit }, { uid, page, size }) {
    try {
      const query_param = {
        uid,
        page,
        size
      }
      const query = queryString.stringify(query_param)
      const spuChecklists_res = await fetch(
        `${api.querySpuChecklists}?${query}`
      )
      const spuChecklistsJson = await spuChecklists_res.json()
      let spuChecklists = []
      if (+spuChecklistsJson.code === 1) {
        spuChecklists = spuChecklistsJson.data || []
        // commit('setSpuChecklistsLength', spuChecklists.length)
      }
      return spuChecklists
    } catch (e) {
      console.log(e)
    }
  },
  // 分享赚添加spu到清单
  async addSpuChecklist({ commit }, { uid, spuId }) {
    try {
      const param = JSON.stringify({
        uid,
        spuId
      })
      console.log(param)
      const res = await fetch(api.addSpuChecklist, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        method: 'POST',
        body: queryString.stringify({ param }),
        credentials: 'include'
      })
      const json = await res.json()
      return json
    } catch (e) {
      console.log(e)
    }
  },
  // 删除清单列表的商品
  async deleteChecklistBySpuId({ commit }, { uid, spuIds }) {
    try {
      const param = JSON.stringify({
        uid,
        spuIds
      })
      console.log(param)
      const res = await fetch(api.deleteChecklistBySpuId, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        method: 'POST',
        body: queryString.stringify({ param }),
        credentials: 'include'
      })
      const json = await res.json()
      return json
    } catch (e) {
      console.log(e)
    }
  }
}
